<template>
  <div
    class="table-row-holder"
    :class="{'selected': checked}">
    <div
      class="custom-table-row c-float">
      <!-- CHECKBOX -->
      <div v-if="checkbox" class="checkbox-cell">
        <Checkbox
          v-model="checked"
          @change="onChange" />
      </div>

      <div class="data-cell" @click="rowAction">
        <div class="top-row flex">
          <div class="info-box fix-width-position">
            <p class="small-text">{{ formatDate(listItem.pickup_date, 'shipment') }}</p>
            <p class="big-text">
              <span class="cut-text medium">{{ listItem.city }}</span>
              <span class="align-middle">{{ `, ${ countryAlpha2(listItem.country_id)}` }}</span>
            </p>
            <p class="small-text tooltip-holder">
              <span class="cut-text small">{{ listItem.company_name ||  listItem.name}}</span>
              <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRef' }"
                  name="info"
                  size="15" />
            <div class="info-tooltip-window" ref="tooltipRef">
              <p v-if="listItem.company_name">{{ listItem.company_name }}</p>
              <p v-if="listItem.name">{{ listItem.name }}</p>
              <p v-if="listItem.address_1">{{ listItem.address_1 }}</p>
              <p v-if="listItem.address_2">{{ listItem.address_2 }}</p>
              <p v-if="listItem.post_code || listItem.city">{{ `${listItem.post_code} ${listItem.city}` }}</p>
              <p v-if="listItem.state">{{ listItem.state }}</p>
              <p v-if="listItem.country_id">{{ countryName(listItem.country_id) }}</p>
              <p v-if="listItem.phone">{{ `+${listItem.phone}` }}</p>
              <p v-if="listItem.email">{{ listItem.email }}</p>
            </div>
            </span>
            </p>
          </div>
          <div class="middle-box status-box">
            <div
              class="shipment-status-bar step1">
              <svg class="stroke-dashed" xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="0" x2="100%" y2="0" />
              </svg>
              <div class="icon-point">
                <p class="status-text">{{ $t('waiting_for_booking') }}</p>
                <Icon
                  :name="'pin'"
                  size="15" />
              </div>
              <div class="point-one"></div>
              <div class="point-two"></div>
            </div>
            <p class="update-info">
<!--              {{ `${$t('last_update')}` }} <span style="text-transform: lowercase">{{ `${formatDate(listItem.shipment_status_date, 'shipment_last_update')}` }} </span> |-->
<!--              {{ $t(listItem.shipment_status_message) }}-->
            </p>
          </div>
          <div class="info-box fix-width-position">
            <p class="small-text">{{ `${listItem.packages_count} colli` }}</p>
            <p class="big-text">
              <span class="cut-text medium">{{ parseFloat(listItem.weight ? listItem.weight : 0) | weight }}</span>
            </p>
            <p class="small-text">
              <span class="cut-text medium">{{ `${getVolumeText(listItem.vol_dm3)}` }}</span><span style="vertical-align: super;
                        font-size: 10px;">3</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import mixin from '@/mixins/mixins.js';
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import Btn from '@/components/elements/buttons';
import LogosSVG from "@/assets/images/logosSVG";
import date from '@/mixins/date'

export default {
  name: 'NotPlannedPickupsRow',
  mixins: [mixin, date],
  components: {
    Checkbox, Btn, LogosSVG
  },
  props: [
    'checkbox',
    'checked',
    'listItem',
    'data',
    'rowActionParameter',
    'dropdown',
    'iconKey',
  ],
  data() {
    return {
      selected: false,
      isDropOpened: false,
    };
  },
  methods: {
    countryAlpha2(id) {
      return this.getCountry(id, 'alpha2');
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    rowAction() {
      this.$router.push(`/pickups/not-planned/${this.listItem.id}`);
    },
    countryName(id){
      return this.getCountry(id, 'name');
    },
    onChange() {
      this.$emit('updateSelect', this.listItem.id);
    }
  },
}
</script>
